import { SetGetCashiersProfile } from './thunk/setGetCashiersProfile'
import { SetGetCategoriesList } from './thunk/setGetCategoriesList';

export const Thunks = {
    SetGetCashiersProfile,
    SetGetCategoriesList
}